module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/Gorilla-64746c3850b3e72d7cb72b6666791ff2.png";